import React from "react";
import { NavLink } from "react-router-dom";
import { Compass, CreditCard, Calendar, Newspaper, User, ShieldCheck } from "lucide-react";
import { useApp } from "@/context/AppContext";

const ITEMS = [
  { key: "home", to: "/app/home", icon: Compass },
  { key: "my_card", to: "/app/card", icon: CreditCard },
  { key: "events", to: "/app/events", icon: Calendar },
  { key: "news", to: "/app/news", icon: Newspaper },
  { key: "profile", to: "/app/profile", icon: User },
  { key: "membership", to: "/app/membership", icon: ShieldCheck },
];

export function BottomNav() {
  const { t } = useApp();
  return (
    <nav
      className="fixed bottom-0 inset-x-0 z-40 border-t border-[color:var(--cu-border)]"
      style={{ background: "rgba(10,9,8,0.82)", backdropFilter: "blur(18px)", WebkitBackdropFilter: "blur(18px)", paddingBottom: "env(safe-area-inset-bottom)" }}
      data-testid="bottom-nav"
    >
      <div className="max-w-xl mx-auto grid grid-cols-6">
        {ITEMS.map(({ key, to, icon: Icon }) => (
          <NavLink
            key={key}
            to={to}
            data-testid={`nav-item-${key.replace("_", "-") === "my-card" ? "card" : key}`}
            className="relative flex flex-col items-center justify-center gap-1 py-2.5"
          >
            {({ isActive }) => (
              <>
                {isActive && <span className="absolute top-0 w-8 h-[2px] rounded-full" style={{ background: "var(--cu-gold)" }} />}
                <Icon size={19} className="transition-colors" style={{ color: isActive ? "var(--cu-gold)" : "var(--cu-muted)" }} />
                <span className="text-[0.56rem] tracking-[0.1em] uppercase font-mono-cu transition-colors" style={{ color: isActive ? "var(--cu-gold-light)" : "var(--cu-muted)" }}>
                  {t(key)}
                </span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
